<template>
  <div class="x-tag">
    <span class="x-tag-text">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'XTag',
  props: {
    label: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.x-tag {
  display: inline-block;
  padding: 0 0.86rem;
  height: 1.72rem;
  line-height: 1.72rem;
  border-radius: 0.86rem;
  background-color: $--app-tag-bgColor;
}
</style>